import ITarotFortune from "@/interfaces/astrology/tarot/ITarotFortune";
import { ActionContext } from 'vuex';

import IPayloadQuery from '@/interfaces/IPayloadQuery';
import IState from '@/interfaces/IState';
import { extractData, extractLinks } from '@/libs/backend/apimapper';

export default async (context: ActionContext<IState, IState>, payload: IPayloadQuery) => {
    const dataToStore = (sourceData: ITarotFortune) => {
        context.commit('tarotFortunesUpload', sourceData);
    };

    try {
        const tarotFortunes = await context.dispatch('backendTalker', {
            request: 'tarotFortunesList',
            query: payload.query
        });

        if (!tarotFortunes) {
            return Promise.reject('Incorrect tarot fortunes data from backend');
        }

        if (payload.metaData) {
            dataToStore(extractData(tarotFortunes.data));
            return extractLinks(tarotFortunes.data)
        } else {
            dataToStore(tarotFortunes.data)
        }
    } catch (err) {
        return Promise.reject(err);
    }
};
